var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Field, useSlotRecipe, VStack } from "@chakra-ui/react";
import { CountryDropdown } from "@/components/SearchForm/CountryDropdown";
import { LocationAutocompleteInput, QueryAutocompleteInput, CompanyAutocompleteInput, } from "@/components/cortex";
import { JobCategoryMultiSelect } from "./JobCategoryMultiSelect";
import { RemoteOnlyToggle } from "./RemoteOnlyToggle";
export function SearchFormChildren(_a) {
    var modules = _a.modules;
    var recipe = useSlotRecipe({ key: "SearchFormChildren" });
    var recipeProps = recipe.splitVariantProps({})[0];
    var styles = recipe(recipeProps);
    return (_jsxs(VStack, { children: [_jsxs(Box, __assign({ css: styles.container }, { children: [_jsx(Field.Root, __assign({ css: styles.what }, { children: _jsx(QueryAutocompleteInput, {}) })), _jsx(Field.Root, __assign({ css: styles.where }, { children: _jsx(LocationAutocompleteInput, {}) })), _jsx(Field.Root, __assign({ css: styles.submit }, { children: _jsx(Button, __assign({ css: styles.search, type: "submit", name: "search" }, { children: "Search" })) }))] })), (modules.countryDropdown ||
                modules.remoteOnlyToggle ||
                modules.companyFilter ||
                modules.occupationsFilter) && (_jsxs(Box, __assign({ css: styles.container }, { children: [modules.countryDropdown && (_jsx(Field.Root, __assign({ css: styles.countryDropdown }, { children: _jsx(CountryDropdown, {}) }))), modules.remoteOnlyToggle && (_jsx(Field.Root, __assign({ css: styles.remoteOnlyToggle }, { children: _jsx(RemoteOnlyToggle, {}) }))), modules.companyFilter && (_jsx(Field.Root, __assign({ css: styles.filter }, { children: _jsx(CompanyAutocompleteInput, {}) }))), modules.occupationsFilter && (_jsx(Field.Root, __assign({ css: styles.jobCategoryFilter }, { children: _jsx(JobCategoryMultiSelect, {}) })))] })))] }));
}
